import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OPTIONS from '../Options.js';
import { withClinicalData } from '../contexts/clinicalData';

import QALayout from '../layout/QA';
import Questionnaire from '../components/Questionnaire';

import Clipboard from 'images/ask/icons/clipboard.svg';

import patientQuestions from '../data/questionnaire/patient';

import SegmentAnalytics from '../../../helpers/SegmentAnalytics.js';


class Patient extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      ...this.resolveState(props)
    };
  }

  resolveState(props) {
    const clinicalData = props.clinicalData;
    const persistOnBackButton = OPTIONS.patient.persistAnswersOnBackButton;

    const answers = persistOnBackButton ? clinicalData.patient : undefined;
    const questions = patientQuestions;

    return { answers, questions };
  }

  render() {
    return (
      <QALayout
        className="patient-view"
        completionPercentage={40}
        sidebar={
          <React.Fragment>
            <img className="header-icon" src={Clipboard} />
            <h2>A little more information</h2>
            <p>This information will help us narrow down possible conditions and give you more accurate results.</p>
          </React.Fragment>
        }
        content={
          <Questionnaire
            answers={this.state.answers}
            questions={this.state.questions}
            onButtonNext={this.onButtonNext.bind(this)}
            onButtonPrevious={this.props.history.goBack}
            autoSubmit={OPTIONS.patient.autoSubmit}
            submitting={this.state.submitting}
          />
        }
      />
    );
  }

  onButtonNext(data) {
    this.setState({ submitting: true });

    SegmentAnalytics.track('Patient data entered', {
      sex: data.find(d => d.id === 'sex').choice_id,
      age: data.find(d => d.id === 'age').choice_id
    });

    this.props.clinicalData.setPatientData(data);
  }
}

Patient.defaultProps = {};

Patient.propTypes = {
  clinicalData: PropTypes.object.isRequired,
  history: PropTypes.object
};

export { Patient };
export default withClinicalData(Patient);
